import { render } from "./Poly.vue?vue&type=template&id=3e2a0972"
import script from "./Poly.vue?vue&type=script&lang=js"
export * from "./Poly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__